import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

const isPresentationalMenuShownSelector = (state: AppState) => state.frontendState.mapPresentational.isPresentationalMenuShown;
export const useIsPresentationalMenuShownSelector = () => useSelector(isPresentationalMenuShownSelector);

const presentationalMapViewSelector = (state: AppState) => state.frontendState.mapPresentational.view;
export const usePresentationalMapViewSelector = () => useSelector(presentationalMapViewSelector);

const availablePresentationalGroupingColumnsSelector = (state: AppState) => state.frontendState.mapPresentational.availableGroupingColumns;
export const useAvailablePresentationalGroupingColumnsSelector = () => useSelector(availablePresentationalGroupingColumnsSelector);
